import { Config } from '../video-data/config';
import { assertMinimum } from '../validators';
import { BaseTimeline } from './BaseTimeline';

/**
 * A type of timeline that can be placed anywhere under a parent.
 *
 * The placement is controlled by setting the relativeStartTime. This makes it possible to place
 * child timelines be under their parent regardless of where the siblings are placed.
 *
 * Moving or changing the duration of a ConcurrentTimeline does not influence its siblings in
 * any way.
 */
export class ConcurrentTimeline extends BaseTimeline {
    override _classType = Config.CONCURRENT_TIMELINE_TYPE;

    /**
     * Set the start time of this timeline relative to its parent.
     * This cannot be set if there is no parent and similarly returns undefined
     * if the timeline doesn't have a parent.
     */
    override set relativeStartTime(value: number | undefined) {
        if (value === this._relativeStartTime) {
            return;
        }
        if (!this.parent) {
            throw new Error('Cannot set relativeStartTime without a parent timeline');
        }
        // A timeline cannot start before its parent
        assertMinimum(value!, 0);
        this.storeRelativeStartTime(value!);
        this.requiresUpdate = true;
    }

    override get relativeStartTime() {
        return super.relativeStartTime;
    }
}
